/** Identidad del sitio, en un solo lugar para no repetir el nombre a mano. */
export const SITE_NAME = 'Club Accesible';
export const SITE_DOMAIN = 'accesible.club';
export const SITE_TAGLINE = 'Club Accesible — Tecnología para todos, aprendizaje en comunidad.';
